import { Module } from 'vuex';
import { ApplicationTemplateState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: ApplicationTemplateState = {
    templates: undefined,
    templateCount: 0,
    templateDetails: undefined,
    index: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const applicationTemplate: Module<ApplicationTemplateState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
